// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowDownTwoRectangles } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-down-two-rectangles': IconArrowDownTwoRectangles;
    }
}

/**
 * The icon component for the 'arrowDownTwoRectangles' icon
 */
export class IconArrowDownTwoRectangles extends IconSvg {
    public constructor() {
        super(arrowDownTwoRectangles);
    }
}

registerIconSvg('icon-arrow-down-two-rectangles', IconArrowDownTwoRectangles);
export const iconArrowDownTwoRectanglesTag = 'nimble-icon-arrow-down-two-rectangles';
